<template>
  <PrepTasks
    team="chopping"
    :team-filter="teamFilter"
    show-late-warnings
    :late-warning-priority-deadlines="lateWarningPriorityDeadlines"
    :can-set-estimate="!$route.meta.readOnly"
    one-task-at-a-time
  />
</template>

<script>

import PrepTasks from '@/components/tasks/PrepTasks';
import {DEFAULT_PRIORITY_DEADLINES, fetchPriorityDeadlines} from '@/utils/tasks/priority-deadlines';

export default {
  name: "ChoppingTasks",
  components: {PrepTasks},
  data() {
    return {
      teamFilter: ['prep', 'veg', 'misc'],
      lateWarningPriorityDeadlines: DEFAULT_PRIORITY_DEADLINES.chopping
    }
  },
  async mounted() {
    const deadlines = await fetchPriorityDeadlines();
    this.lateWarningPriorityDeadlines = deadlines.chopping;
  }
}
</script>

<style scoped>

</style>
